export default __webpack_public_path__ + "static/media/actual_calcio.206d6fae.png";